(() => {
  function init(root) {
    if (root.dataset.agPurchaseReady) return;
    const dataNode = root.querySelector('[data-ag-purchase-data]');
    if (!dataNode) return;
    root.dataset.agPurchaseReady = 'true';
    const data = JSON.parse(dataNode.textContent);
    const compact = data.galleryMode === true && data.compactGallery === true;
    const events = new AbortController();
    const on = (target, name, fn, options = {}) => target?.addEventListener(name, fn, { ...options, signal: events.signal });
    const button = root.querySelector('[data-ag-add-selected]');
    const form = button.form;
    const productForm = button.closest('product-form');
    const options = [...root.querySelectorAll('[data-ag-box-option]')];
    const zoomButtons = [...root.querySelectorAll('[data-ag-box-zoom], [data-ag-box-preview]')];
    const continueLink = root.querySelector('[data-ag-continue]');
    const price = root.querySelector('[data-ag-variant-price]');
    const fixed = root.querySelector('[data-ag-pdp-fixed]');
    const actions = root.querySelector('[data-ag-pdp-actions]');
    const stickyBuy = fixed.querySelector('[data-ag-sticky-buy]');
    const stickyEnquiryNote = fixed.querySelector('[data-ag-sticky-enquiry-note]');
    const returnToChoices = fixed.querySelector('[data-ag-return-to-choices]');
    const footerSpacer = document.createElement('div');
    footerSpacer.className = 'ag-pdp-footer-spacer';
    footerSpacer.setAttribute('aria-hidden', 'true');
    document.body.append(footerSpacer);
    const choicesStart = root.querySelector('.ag-pdp-box-grid') || root.querySelector('[data-ag-option-selected-line]');
    const mobileQuery = matchMedia('(max-width: 767px)');
    const banner = root.querySelector('[data-ag-pdp-added]');
    const addedText = banner.querySelector('[data-ag-banner-label]').textContent;
    let pendingSelection = null;
    root.append(fixed, banner);
    const dialog = root.querySelector('[data-ag-variant-preview]');
    const sources = [...root.querySelectorAll('[data-ag-preview-source]')];
    let previewSources = sources;
    const optionGallery = root.querySelector('[data-ag-option-gallery]');
    const optionTrack = optionGallery?.querySelector('[data-ag-option-track]');
    let optionSources = [], optionIndex = 0, optionDrag = null, optionFrame = null, suppressOptionClick = false;
    // Native :focus-visible may persist when a touch-opened dialog receives focus.
    // Track keyboard use for B so pointer opening stays plain, without removing keyboard focus.
    const setKeyboardInput = keyboard => {
      dialog.classList.toggle('ag-pdp-preview--keyboard', keyboard);
      if (data.galleryMode) root.classList.toggle('ag-pdp-input--keyboard', keyboard);
    };
    on(document, 'pointerdown', () => setKeyboardInput(false), {capture:true, passive:true});
    on(document, 'keydown', event => {
      if (['Tab','Enter',' ','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End','Escape'].includes(event.key)) setKeyboardInput(true);
    }, {capture:true});
    const previewImage = dialog.querySelector('[data-ag-preview-fallback]');
    let previewViewer = null, previewViewerObserver = null, previewViewerUpdating = false;
    const previewSelect = dialog.querySelector('[data-ag-preview-select]');
    const previewCounter = dialog.querySelector('[data-ag-preview-counter]');
    const previewError = dialog.querySelector('[data-ag-preview-error]');
    let busy = false, added = false, enquiryAdded = false;
    const initialId = options.find(input => input.checked)?.value || data.initialId;
    let selected = data.variants.find(v => String(v.id) === String(initialId) && (data.galleryMode || data.stockEnquiry || v.available)) || null;
    form.elements.id.value = selected?.id || '';
    let previewIndex = 0, opener = null, savedBody = null, savedY = 0, swipe = null, timer = null, frame = null;
    const headerBottom = () => Math.max(0, ...[...document.querySelectorAll('.m-header, [data-header-wrapper]')]
      .filter(el => el.getClientRects().length).map(el => Math.min(innerHeight / 2, el.getBoundingClientRect().bottom)));
    const modalSelector = 'dialog[open], .pswp--open, .m-cart-drawer--active, .m-open-modal, [role="dialog"][aria-modal="true"]';
    const hasOpenPanel = () => {
      if (dialog.open || document.documentElement.classList.contains('prevent-scroll') ||
          document.documentElement.classList.contains('m:overflow-hidden') || document.body.classList.contains('m:overflow-hidden')) return true;
      return [...document.querySelectorAll(modalSelector)].some(el => {
        const style = getComputedStyle(el);
        return el.getAttribute('aria-hidden') !== 'true' && el.getClientRects().length && style.visibility !== 'hidden' && style.display !== 'none';
      });
    };
    const position = () => {
      frame = null;
      const top = headerBottom();
      root.style.setProperty('--ag-pdp-notice-top', top + 'px');
      const mobileBuy = data.mobileStickyBuy === true && mobileQuery.matches;
      const showEnquiryNote = !!(mobileBuy && data.stockEnquiry && selected && !selected.available && window.AdriaStockEnquiry);
      if (stickyEnquiryNote) stickyEnquiryNote.hidden = !showEnquiryNote;
      fixed.classList.toggle('ag-pdp-fixed--enquiry', showEnquiryNote);
      stickyBuy.hidden = !mobileBuy;
      returnToChoices.hidden = mobileBuy;
      fixed.classList.toggle('ag-pdp-fixed--purchase', mobileBuy);
      root.classList.toggle('ag-pdp-permanent-buy', mobileBuy);
      const spacerDisplay = mobileBuy ? 'block' : 'none';
      if (footerSpacer.style.display !== spacerDisplay) footerSpacer.style.display = spacerDisplay;
      const bottom = innerHeight;
      const contentTop = top;
      const footerVisible = [...document.querySelectorAll('m-footer, .shopify-section-group-footer-group, body > footer')]
        .some(el => { const rect = el.getBoundingClientRect(); return rect.height > 0 && rect.top < bottom && rect.bottom > contentTop; });
      if (mobileBuy) {
        // Fixed bottom: Safari toolbar changes must not toggle or reposition the CTA.
        fixed.hidden = hasOpenPanel();
        if (!fixed.hidden) {
          const height = Math.ceil(fixed.getBoundingClientRect().height) + 'px';
          if (footerSpacer.style.height !== height) footerSpacer.style.height = height;
        }
      } else {
        const passed = actions.getBoundingClientRect().bottom <= top;
        fixed.hidden = dialog.open || !passed || footerVisible;
      }
    };
    const schedulePosition = () => { if (!frame) frame = requestAnimationFrame(position); };
    // Clone trusted, server-rendered SVG only. Shopify option values remain text nodes.
    const setMotifLabel = (element, variantId, name) => {
      if (!element) return;
      const input = options.find(option => option.value === String(variantId));
      const icon = input?.closest('.ag-pdp-box-card')?.querySelector('[data-ag-motif-template]')?.content.querySelector('svg');
      element.replaceChildren();
      if (icon) element.append(icon.cloneNode(true), document.createTextNode(' '));
      const label = document.createElement('span');
      label.textContent = name || '';
      element.append(label);
    };
    const selectionName = variant => data.hasOnlyDefaultVariant ? '' :
      options.find(input => input.value === String(variant?.id))?.dataset.displayName || variant?.title || '';
    const states = () => {
      const enquiry = data.stockEnquiry && selected && !selected.available && window.AdriaStockEnquiry;
      button.disabled = busy || (!selected?.available && !enquiry);
      button.type = added || enquiry ? 'button' : 'submit';
      if (enquiryAdded && !window.AdriaStockEnquiry?.read().items.some(item => item.variantId === String(selected?.id))) enquiryAdded = false;
      button.textContent = enquiry ? window.AdriaStockEnquiry.text[enquiryAdded ? 'view' : 'add'] : added ? button.dataset.cartLabel : button.dataset.addLabel;
      window.AdriaStockEnquiry?.note(button, !!enquiry);
      continueLink.hidden = !added;
      returnToChoices.disabled = busy;
      stickyBuy.disabled = button.disabled;
      stickyBuy.textContent = button.textContent;
      stickyBuy.setAttribute('aria-busy', String(busy));
      options.forEach(input => input.disabled = busy || (!data.galleryMode && !data.stockEnquiry && !data.variants.find(v => String(v.id) === input.value)?.available));
      zoomButtons.forEach(zoom => zoom.disabled = busy);
      productForm.setAttribute('aria-busy', String(busy));
      const selectedName = root.querySelector('[data-ag-option-selected]');
      const optionName = selectionName(selected);
      if (compact) selectedName.textContent = optionName;
      else setMotifLabel(selectedName, selected?.id, optionName);
      selectedName.hidden = !optionName;
      selectedName.classList.toggle('is-unavailable', !!(data.galleryMode && selected && !selected.available && !data.stockEnquiry));
      let availability = root.querySelector('[data-ag-selection-availability]');
      if (data.galleryMode && !availability) {
        availability = document.createElement('span'); availability.dataset.agSelectionAvailability = '';
        availability.className = 'ag-pdp-availability';
        availability.id = form.id + '-availability';
        button.setAttribute('aria-describedby', availability.id);
        stickyBuy.setAttribute('aria-describedby', availability.id);
        root.querySelector('[data-ag-option-selected-line]').append(availability);
      }
      if (availability) availability.textContent = selected && !selected.available ? data.soldOutLabel : '';
      const wishlist = root.querySelector('[data-ag-soldout-wishlist]');
      if (wishlist) wishlist.hidden = !selected || selected.available;

      root.querySelector('[data-ag-option-selected-line]').hidden = !selected || (compact && !optionName);
      schedulePosition();
    };
    const select = (input, changeMedia = true) => {
      const variant = data.variants.find(v => String(v.id) === input?.value && (data.galleryMode || data.stockEnquiry || v.available));
      if (!variant || busy) return;
      const changed = selected?.id !== variant.id;
      selected = variant;
      input.checked = true;
      form.elements.id.value = variant.id;
      if (changed) {
        added = false;
        enquiryAdded = false;
        banner.hidden = true;
        productForm.querySelector('.m-product-form-message').textContent = '';
      }
      const template = root.querySelector(`[data-ag-price-template="${variant.id}"]`);
      if (template) price.replaceChildren(template.content.cloneNode(true));
      const skuRow = root.querySelector('[data-ag-variant-sku-row]');
      if (skuRow.dataset.agSkuSource !== 'component') {
        skuRow.querySelector('[data-ag-variant-sku]').textContent = variant.sku || '';
        skuRow.hidden = !variant.sku;
      }
      if (!data.galleryMode && changeMedia && variant.featured_media?.id) root.querySelectorAll('[data-ag-premium-gallery]').forEach(gallery => {
        gallery.dataset.agRequestedMedia = String(variant.featured_media.id);
        gallery.setActiveMedia?.(variant);
      });
      if (data.galleryMode && changed) renderOptionGallery(variant.id);
      states();
    };
    const blurredPreviewElements = new Map();
    let appliedPreviewBlur = null;
    const setPreviewPageBlur = (enabled, radius = 12) => {
      if (enabled && appliedPreviewBlur !== radius) setPreviewPageBlur(false);
      if (!enabled) {
        blurredPreviewElements.forEach((saved, element) => {
          if (element.style.getPropertyValue('filter') === saved.applied) {
            if (saved.value) element.style.setProperty('filter', saved.value, saved.priority);
            else element.style.removeProperty('filter');
          }
          element.classList.remove('ag-pdp-preview-blur-target');
        });
        blurredPreviewElements.clear();
        appliedPreviewBlur = null;
        return;
      }
      if (blurredPreviewElements.size || radius === 0 || !CSS.supports('filter', 'blur(1px)')) return;
      appliedPreviewBlur = radius;
      // Blur only siblings along the dialog's ancestor path, never its ancestors.
      // This keeps the top-layer photo and controls sharp in WebKit as well.
      let branch = dialog;
      while (branch && branch !== document.body) {
        const parent = branch.parentElement;
        if (!parent) break;
        for (const element of parent.children) {
          if (element === branch || !(element instanceof HTMLElement) || ['SCRIPT','STYLE','LINK','TEMPLATE','META','NOSCRIPT'].includes(element.tagName)) continue;
          const value = element.style.getPropertyValue('filter');
          const priority = element.style.getPropertyPriority('filter');
          const existing = getComputedStyle(element).filter;
          const applied = (existing && existing !== 'none' ? existing + ' ' : '') + `blur(${radius}px)`;
          element.style.setProperty('filter', applied, 'important');
          element.classList.add('ag-pdp-preview-blur-target');
          blurredPreviewElements.set(element, {value, priority, applied});
        }
        branch = parent;
      }
    };
    const unlock = () => {
      setPreviewPageBlur(false);
      if (!savedBody) return;
      Object.entries(savedBody).forEach(([key,value]) => document.body.style[key] = value);
      savedBody = null;
      window.scrollTo({ top: savedY, left: window.scrollX, behavior: 'instant' });
    };
    const syncPreviewLayout = () => {
      if (!data.galleryMode) return;
      const fullscreen = dialog.dataset.previewMode === 'fullscreen';
      const desktop = matchMedia('(min-width: 768px)').matches;
      const percentage = fullscreen ? 100 : Math.min(100, Math.max(50, Number(desktop ? dialog.dataset.previewHeightDesktop : dialog.dataset.previewHeightMobile) || 100));
      const viewport = window.visualViewport;
      dialog.style.setProperty('--ag-preview-vh', ((viewport?.height || innerHeight) / 100) + 'px');
      dialog.style.setProperty('--ag-preview-top', (viewport?.offsetTop || 0) + 'px');
      dialog.style.setProperty('--ag-preview-height', percentage);
      dialog.dataset.previewCompact = String(percentage < 100);
      dialog.dataset.previewBackground = fullscreen ? 'white' : (desktop ? dialog.dataset.previewBackgroundDesktop : dialog.dataset.previewBackgroundMobile) || 'white';
      const suffix = desktop ? 'Desktop' : 'Mobile';
      const value = (key, fallback, max) => {
        const raw = dialog.dataset['preview' + key + suffix];
        const number = raw === undefined || raw === '' ? fallback : Number(raw);
        return Math.min(max, Math.max(0, Number.isFinite(number) ? number : fallback));
      };
      dialog.style.setProperty('--ag-preview-opacity', 1 - value('Transparency', 25, 100) / 100);
      dialog.style.setProperty('--ag-preview-dim', value('Dim', 20, 60) / 100);
      setPreviewPageBlur(dialog.open && dialog.dataset.previewBackground === 'glass', value('Blur', 12, 30));
    };
    const close = () => {
      if (!dialog.open) return;
      destroyPreviewViewer(); resetPreviewDrag(); dialog.close(); unlock(); opener?.focus({ preventScroll: true }); position();
    };
    const showImage = (index, fromViewer = false) => {
      if (previewViewer && !fromViewer) {
        const count = previewSources.length;
        const target = (index % count + count) % count;
        if (target === previewIndex && Math.abs(index - previewIndex) < count) return;
        const step = index - previewIndex;
        if (step === 1) previewViewer.next();
        else if (step === -1) previewViewer.prev();
        else previewViewer.goTo(target);
        return;
      }
      const count = previewSources.length;
      previewIndex = data.galleryMode && count > 0 ? (index % count + count) % count : Math.max(0, Math.min(count - 1, index));
      const source = previewSources[previewIndex];
      if (!source) return;
      previewError.hidden = true;
      previewImage.style.visibility = 'hidden';
      previewImage.src = source.dataset.src;
      previewImage.alt = source.dataset.alt;
      if (previewImage.complete && previewImage.naturalWidth > 0) previewImage.style.visibility = '';
      setMotifLabel(dialog.querySelector('[data-ag-preview-caption]'), source.dataset.variantId, source.dataset.name + (source.dataset.kind ? ' — ' + source.dataset.kind : ''));
      previewCounter.textContent = previewCounter.dataset.template.replace('{index}', previewIndex + 1).replace('{count}', previewSources.length);
      const previous = dialog.querySelector('[data-ag-preview-previous]');
      const next = dialog.querySelector('[data-ag-preview-next]');
      previous.disabled = data.galleryMode ? count < 2 : previewIndex === 0;
      next.disabled = data.galleryMode ? count < 2 : previewIndex === count - 1;
      previous.hidden = next.hidden = data.galleryMode && count < 2;
      const variant = data.variants.find(v => String(v.id) === source.dataset.variantId);
      previewSelect.disabled = !variant || (!variant.available && !data.stockEnquiry);
      previewSelect.textContent = variant && (variant.available || data.stockEnquiry) ? previewSelect.dataset.label : previewSelect.dataset.soldOut;
    };
    const openPreview = (variantId, index, trigger) => {
      if (busy || (data.galleryMode && data.bPreview === false)) return;
      previewSources = data.galleryMode ? sources.filter(source => source.dataset.variantId === String(variantId)) : sources;
      const first = previewSources.findIndex(source => source.dataset.variantId === String(variantId));
      if (first < 0) return;
      opener = trigger; savedY = scrollY;
      savedBody = Object.fromEntries(['position','top','left','right','width'].map(key => [key,document.body.style[key]]));
      Object.assign(document.body.style, { position:'fixed', top:-savedY+'px', left:'0', right:'0', width:'100%' });
      syncPreviewLayout();
      showImage(data.galleryMode ? index : first); dialog.showModal(); syncPreviewLayout(); fixed.hidden = true;
      if (data.galleryMode) createPreviewViewer();
      dialog.querySelector('[data-ag-preview-close]').focus({ preventScroll:true });
    };
    zoomButtons.forEach(zoom => on(zoom, 'click', () => openPreview(zoom.dataset.variantId, 0, zoom)));
    // The album has its own logical index; repeated slides never select a variant.
    let optionOriginals = [], optionCopies = -1, optionCenter = 0, optionDestination = null;
    let optionSettleTimer = null, optionPointer = null, optionTouching = false;
    const optionModulo = index => optionSources.length ? (index % optionSources.length + optionSources.length) % optionSources.length : 0;
    const optionTarget = index => {
      const slide = optionTrack?.children[index];
      if (!slide) return 0;
      return optionTrack.scrollLeft + slide.getBoundingClientRect().left - optionTrack.getBoundingClientRect().left - (optionTrack.clientWidth - slide.offsetWidth) / 2;
    };
    const nearestOptionSlide = () => {
      let best = 0, distance = Infinity;
      for (let i = 0; i < (optionTrack?.children.length || 0); i++) {
        const next = Math.abs(optionTarget(i) - optionTrack.scrollLeft);
        if (next < distance) { best = i; distance = next; }
      }
      return best;
    };
    const optionStatus = () => {
      if (!optionGallery) return;
      optionGallery.querySelector('[data-ag-option-prev]').disabled = optionSources.length < 2;
      optionGallery.querySelector('[data-ag-option-next]').disabled = optionSources.length < 2;
      const counter = optionGallery.querySelector('[data-ag-option-counter]');
      counter.textContent = counter.dataset.template.replace('{index}', optionIndex + 1).replace('{count}', optionSources.length);
    };
    const moveOptionSlide = (physicalIndex, instant = false) => {
      if (!optionTrack?.children.length) return;
      const index = Math.max(0, Math.min(optionTrack.children.length - 1, physicalIndex));
      optionIndex = optionModulo(index);
      optionDestination = instant ? null : index;
      optionTrack.scrollTo({left: optionTarget(index), behavior: instant || matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      optionStatus();
    };
    const moveOption = (index, instant = false) => moveOptionSlide(optionCenter + optionModulo(index), instant);
    const settleOption = () => {
      clearTimeout(optionSettleTimer);
      optionSettleTimer = null;
      if (optionPointer !== null || optionTouching || optionDrag || !optionSources.length) return;
      // A scrollend from the previous transition may arrive after another click.
      if (optionDestination !== null && Math.abs(optionTarget(optionDestination) - optionTrack.scrollLeft) > 1.5) {
        scheduleOptionSettle();
        return;
      }
      const physical = nearestOptionSlide();
      optionIndex = optionModulo(physical);
      optionDestination = null;
      const previousSize = optionTrack.style.getPropertyValue('--ag-option-slide-size');
      const previousCopies = optionCopies;
      sizeOptionSlides();
      const canonical = optionCenter + optionIndex;
      // Wait for native momentum/snap to finish, then swap identical copies.
      if (physical !== canonical || previousSize !== optionTrack.style.getPropertyValue('--ag-option-slide-size') || previousCopies !== optionCopies) {
        const active = document.activeElement;
        const activeSlide = active?.closest('[data-option-index]');
        optionTrack.scrollTo({left: optionTarget(canonical), behavior:'instant'});
        if (activeSlide && optionTrack.contains(activeSlide)) optionOriginals[Number(activeSlide.dataset.optionIndex)]?.focus({preventScroll:true});
        if (opener && optionTrack.contains(opener)) opener = optionOriginals[Number(opener.dataset.optionIndex)] || opener;
      }
      optionStatus();
    };
    const scheduleOptionSettle = () => {
      clearTimeout(optionSettleTimer);
      optionSettleTimer = setTimeout(settleOption, 180);
    };
    const stepOption = direction => {
      if (optionSources.length < 2) return;
      let from = optionDestination ?? nearestOptionSlide();
      if (from + direction < optionSources.length || from + direction >= optionTrack.children.length - optionSources.length) {
        moveOption(optionModulo(from), true);
        from = optionCenter + optionIndex;
      }
      moveOptionSlide(from + direction);
    };
    const rebuildOptionCopies = (slideWidth, gap) => {
      // Extra whole albums cover both edges, even with narrow portrait slides.
      const copies = optionSources.length > 1 ? Math.max(2, Math.ceil(optionTrack.clientWidth / Math.max(1, (slideWidth + gap) * optionSources.length))) : 0;
      if (copies === optionCopies) return;
      const focused = document.activeElement;
      const focusedIndex = optionTrack.contains(focused) ? focused.closest('[data-option-index]')?.dataset.optionIndex : null;
      const openerIndex = opener && optionTrack.contains(opener) ? opener.dataset.optionIndex : null;
      optionCopies = copies;
      optionCenter = copies * optionSources.length;
      const slides = [];
      for (let cycle = -copies; cycle <= copies; cycle++) optionOriginals.forEach(original => {
        if (!cycle) { slides.push(original); return; }
        const copy = original.cloneNode(true);
        copy.dataset.optionClone = 'true';
        copy.setAttribute('aria-hidden','true');
        copy.tabIndex = -1;
        slides.push(copy);
      });
      optionTrack.replaceChildren(...slides);
      if (focusedIndex !== null) optionOriginals[Number(focusedIndex)]?.focus({preventScroll:true});
      if (openerIndex !== null) opener = optionOriginals[Number(openerIndex)] || opener;
    };
    // Measure the full viewport; preserve an actual image edge beyond the gap.
    const sizeOptionSlides = () => {
      if (!optionTrack) return;
      const percent = Math.min(100, Math.max(50, parseFloat(getComputedStyle(optionGallery).getPropertyValue('--ag-option-slide-percent')) || 84));
      const width = optionTrack.clientWidth;
      const gap = parseFloat(getComputedStyle(optionTrack).columnGap) || 0;
      let slideWidth = width * percent / 100;
      if (optionSources.length > 1) {
        const imageWidths = optionOriginals.map(slide => slide.querySelector('img'))
          .filter(img => img.naturalWidth > 0 && img.naturalHeight > 0)
          .map(img => optionTrack.clientHeight * img.naturalWidth / img.naturalHeight);
        slideWidth = Math.min(slideWidth, Math.max(1, width - 2 * (gap + 16)), ...imageWidths);
      }
      optionTrack.style.setProperty('--ag-option-slide-size', slideWidth + 'px');
      optionTrack.style.setProperty('--ag-option-inset', ((width - slideWidth) / 2) + 'px');
      rebuildOptionCopies(slideWidth, gap);
    };
    const layoutOptionSlides = () => {
      if (optionPointer !== null || optionTouching || optionDrag) return;
      sizeOptionSlides();
      moveOption(optionIndex, true);
    };
    const choiceLayout = optionGallery?.closest('.ag-pdp-boxes--gallery');
    const desktopLayout = matchMedia('(min-width: 768px)');
    const syncChoiceLayout = () => {
      if (!choiceLayout) return;
      if (compact) { layoutOptionSlides(); return; }
      const grid = choiceLayout.querySelector('.ag-pdp-box-grid');
      const placement = (desktopLayout.matches ? choiceLayout.dataset.choicePositionDesktop : choiceLayout.dataset.choicePositionMobile) || choiceLayout.dataset.choicePosition || 'below';
      const focused = document.activeElement;
      choiceLayout.dataset.choicePosition = placement;
      if (placement === 'above' && grid.nextElementSibling !== optionGallery) grid.after(optionGallery);
      if (placement !== 'above' && optionGallery.nextElementSibling !== grid) grid.before(optionGallery);
      if (focused !== document.activeElement && choiceLayout.contains(focused)) focused.focus({preventScroll:true});
      layoutOptionSlides();
    };
    on(desktopLayout, 'change', syncChoiceLayout);
    const renderOptionGallery = variantId => {
      if (!optionGallery) return;
      clearTimeout(optionSettleTimer);
      cancelAnimationFrame(optionFrame); optionFrame = null;
      optionSources = sources.filter(source => source.dataset.variantId === String(variantId));
      optionIndex = 0; optionCopies = -1; optionDestination = null;
      optionOriginals = optionSources.map((source, index) => {
        const slide = document.createElement(data.bPreview === false ? 'div' : 'button');
        if (data.bPreview !== false) slide.type = 'button'; slide.className = 'ag-pdp-option-gallery__slide'; slide.dataset.optionIndex = index;
        const zoomLabel = optionGallery.dataset.previewLabel + ': ' + source.dataset.name;
        if (data.bPreview !== false) slide.setAttribute('aria-label', zoomLabel + ' — ' + (index + 1));
        const img = document.createElement('img');
        img.alt = source.dataset.alt; img.draggable = false; img.loading = 'eager'; img.src = source.dataset.src;
        img.addEventListener('load', () => {
          if (!slide.isConnected || events.signal.aborted) return;
          layoutOptionSlides();
        }, {once:true});
        img.addEventListener('error', () => {
          if (!slide.isConnected || events.signal.aborted) return;
          // Apply the same error presentation to originals and their visual copies.
          optionTrack.querySelectorAll(`[data-option-index="${index}"]`).forEach(item => {
            item.querySelector('img').hidden = true;
            if (item.querySelector('span')) return;
            const message = document.createElement('span'); message.textContent = previewError.textContent; item.append(message);
          });
        }, {once:true});
        slide.append(img); return slide;
      });
      optionTrack.hidden = !optionSources.length;
      optionGallery.querySelector('[data-ag-option-empty]').hidden = !!optionSources.length;
      optionGallery.querySelector('[data-ag-option-nav]').hidden = optionSources.length < 2;
      optionGallery.classList.toggle('is-single', optionSources.length < 2);
      sizeOptionSlides();
      moveOption(0, true);
    };
    on(optionTrack, 'click', event => {
      if (data.bPreview === false) return;
      if (suppressOptionClick) { event.preventDefault(); event.stopPropagation(); return; }
      const slide = event.target.closest('[data-option-index]');
      const source = optionSources[Number(slide?.dataset.optionIndex)];
      if (slide && source) openPreview(source.dataset.variantId, Number(slide.dataset.optionIndex), slide);
    });
    on(optionTrack, 'dragstart', event => event.preventDefault());
    // Touch scrolling cancels pointer events before the finger is lifted.
    on(optionTrack, 'touchstart', () => { optionTouching = true; clearTimeout(optionSettleTimer); }, {passive:true});
    const endOptionTouch = event => {
      optionTouching = event.touches.length > 0;
      if (!optionTouching) { optionPointer = null; scheduleOptionSettle(); }
    };
    on(optionTrack, 'touchend', endOptionTouch, {passive:true});
    on(optionTrack, 'touchcancel', endOptionTouch, {passive:true});
    on(optionTrack, 'pointerdown', event => {
      if (!event.isPrimary || event.button !== 0) return;
      optionPointer = event.pointerId;
      clearTimeout(optionSettleTimer);
      optionDestination = null;
      suppressOptionClick = false;
      if (event.pointerType === 'mouse' && optionSources.length > 1) optionDrag = {id:event.pointerId, x:event.clientX, y:event.clientY, start:optionTrack.scrollLeft, moved:false};
    });
    on(window, 'pointermove', event => {
      if (!optionDrag || event.pointerId !== optionDrag.id) return;
      const dx = event.clientX - optionDrag.x, dy = event.clientY - optionDrag.y;
      if (!optionDrag.moved && Math.abs(dx) >= 6 && Math.abs(dx) > Math.abs(dy)) {
        optionDrag.moved = true; optionTrack.classList.add('is-dragging'); optionTrack.setPointerCapture(event.pointerId);
      }
      if (optionDrag.moved) { event.preventDefault(); optionTrack.scrollLeft = optionDrag.start - dx; }
    });
    const endOptionDrag = event => {
      if (event.type === 'blur') optionTouching = false;
      if (event.pointerId !== undefined && event.pointerId !== optionPointer && event.pointerId !== optionDrag?.id) return;
      optionPointer = null;
      const dragged = optionDrag?.moved; optionDrag = null;
      optionTrack?.classList.remove('is-dragging');
      if (dragged) {
        suppressOptionClick = true;
        moveOptionSlide(nearestOptionSlide());
      }
      scheduleOptionSettle();
    };
    ['pointerup','pointercancel','lostpointercapture'].forEach(name => on(window,name,endOptionDrag));
    on(window, 'blur', endOptionDrag);
    on(optionTrack, 'keydown', event => {
      suppressOptionClick = false;
      if (['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) {
        event.preventDefault();
        if (event.key === 'Home' || event.key === 'End') moveOption(event.key === 'Home' ? 0 : optionSources.length - 1);
        else stepOption(event.key === 'ArrowLeft' ? -1 : 1);
      }
    });
    on(optionTrack, 'scroll', () => {
      scheduleOptionSettle();
      if (optionFrame) return;
      optionFrame = requestAnimationFrame(() => {
        optionFrame = null;
        if (!optionSources.length) return;
        optionIndex = optionModulo(nearestOptionSlide());
        optionStatus();
      });
    }, {passive:true});
    on(optionTrack, 'scrollend', settleOption);
    on(optionTrack, 'wheel', () => { optionDestination = null; scheduleOptionSettle(); }, {passive:true});
    on(optionGallery?.querySelector('[data-ag-option-prev]'), 'click', () => stepOption(-1));
    on(optionGallery?.querySelector('[data-ag-option-next]'), 'click', () => stepOption(1));
    const galleryResize = optionTrack ? new ResizeObserver(layoutOptionSlides) : null;
    if (optionTrack) galleryResize.observe(optionTrack, {box:'border-box'});
    on(previewImage,'load',() => previewImage.style.visibility = '');
    on(previewImage,'error',() => previewError.hidden = false);
    dialog.querySelectorAll('[data-ag-preview-close]').forEach(el => on(el,'click',close));
    let backdropGesture = null;
    const outsidePreview = event => {
      const rect = dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    };
    on(dialog, 'pointerdown', event => {
      if (!data.galleryMode || !event.isPrimary || event.button !== 0) return;
      backdropGesture = {id:event.pointerId, x:event.clientX, y:event.clientY, outside:outsidePreview(event)};
    });
    on(dialog, 'pointerup', event => {
      const gesture = backdropGesture; backdropGesture = null;
      if (gesture?.id !== event.pointerId || !gesture.outside || !outsidePreview(event)) return;
      if (Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) < 10) close();
    });
    on(dialog, 'pointercancel', () => { backdropGesture = null; });
    on(window, 'resize', syncPreviewLayout);
    on(window.visualViewport, 'resize', syncPreviewLayout);
    on(window.visualViewport, 'scroll', syncPreviewLayout);
    on(dialog,'cancel',event => { event.preventDefault(); close(); });
    on(dialog,'close',() => { destroyPreviewViewer(); unlock(); schedulePosition(); });
    on(dialog,'keydown',event => {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.preventDefault(); showImage(previewIndex + (event.key === 'ArrowLeft' ? -1 : 1));
      } else if (event.key === 'Tab') {
        const nodes = [...dialog.querySelectorAll('button:not(:disabled)')].filter(el => el.getClientRects().length);
        if (!nodes.length) return;
        event.preventDefault();
        const index = nodes.indexOf(document.activeElement);
        nodes[(index + (event.shiftKey ? -1 : 1) + nodes.length) % nodes.length].focus();
      }
    });
    on(dialog.querySelector('[data-ag-preview-previous]'),'click',() => showImage(previewIndex - 1));
    on(dialog.querySelector('[data-ag-preview-next]'),'click',() => showImage(previewIndex + 1));
    on(previewSelect,'click',() => {
      if (data.galleryMode) return;
      const input = options.find(option => option.value === previewSources[previewIndex].dataset.variantId);
      if (!input || input.disabled) return;
      select(input); close(); input.focus({ preventScroll:true });
      const rect = input.closest('.ag-pdp-box-card').getBoundingClientRect();
      if (rect.top < headerBottom() || rect.bottom > innerHeight) {
        window.scrollTo({ top: scrollY + rect.top - headerBottom() - 20, behavior:'instant' });
      }
    });
    const stage = dialog.querySelector('[data-ag-preview-stage]');
    const previewPanel = dialog.querySelector('[data-ag-sheet-preview-panel]');
    const previewHandle = dialog.querySelector('[data-ag-preview-handle]');
    let previewDragTimer = null, previewTouches = 0;
    const reducedMotion = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
    function resetPreviewDrag() {
      clearTimeout(previewDragTimer); previewDragTimer = null; swipe = null;
      previewPanel?.style.removeProperty('transform');
      previewPanel?.style.removeProperty('transition');
    }
    const restorePreviewDrag = () => {
      swipe = null;
      previewPanel.style.transition = reducedMotion() ? 'none' : 'transform 180ms ease-out';
      previewPanel.style.transform = 'translateY(0)';
      clearTimeout(previewDragTimer);
      previewDragTimer = setTimeout(resetPreviewDrag, reducedMotion() ? 0 : 190);
    };
    const beginPreviewDrag = event => {
      if (event.currentTarget === stage && previewViewer) return;
      if (!event.isPrimary || event.button !== 0 || previewTouches > 1) { if (swipe) restorePreviewDrag(); return; }
      if (event.target.closest('button,a,input')) return;
      if (previewDragTimer) resetPreviewDrag();
      const mobile = data.galleryMode && matchMedia('(max-width: 767px)').matches;
      swipe = {id:event.pointerId, x:event.clientX, y:event.clientY, time:performance.now(),
        lastY:event.clientY, lastTime:performance.now(), velocity:0, mobile,
        handle:event.currentTarget === previewHandle, scrollTop:previewPanel.scrollTop, direction:null, dy:0};
      event.currentTarget.setPointerCapture(event.pointerId);
      previewPanel.style.transition = 'none';
    };
    const movePreviewDrag = event => {
      if (event.currentTarget === stage && previewViewer) return;
      if (!swipe || swipe.id !== event.pointerId || !swipe.mobile) return;
      const dx = event.clientX - swipe.x, dy = event.clientY - swipe.y;
      if (!swipe.direction && Math.max(Math.abs(dx), Math.abs(dy)) >= 10) {
        if (!swipe.handle && Math.abs(dx) > Math.abs(dy) * 1.25) swipe.direction = 'horizontal';
        else if (Math.abs(dy) > Math.abs(dx) * 1.25) {
          swipe.direction = dy > 0 && (swipe.handle || swipe.scrollTop <= 1) ? 'dismiss' : 'scroll';
        }
      }
      if (swipe.direction === 'dismiss') {
        const now = performance.now();
        swipe.velocity = (event.clientY - swipe.lastY) / Math.max(1, now - swipe.lastTime);
        swipe.lastY = event.clientY; swipe.lastTime = now; swipe.dy = Math.max(0, dy);
        previewPanel.style.transform = `translateY(${swipe.dy}px)`;
      } else if (swipe.direction === 'scroll') previewPanel.scrollTop = swipe.scrollTop - dy;
    };
    const endPreviewDrag = event => {
      if (event.currentTarget === stage && previewViewer) return;
      if (!swipe || swipe.id !== event.pointerId) return;
      const gesture = swipe; swipe = null;
      const dx = event.clientX - gesture.x, dy = event.clientY - gesture.y;
      if (gesture.mobile && gesture.direction === 'dismiss') {
        const fast = performance.now() - gesture.lastTime < 120 && gesture.velocity > 0.6 && dy >= 40;
        if (dy >= Math.min(100, dialog.clientHeight * 0.2) || fast) {
          previewPanel.style.transition = reducedMotion() ? 'none' : 'transform 180ms ease-out';
          previewPanel.style.transform = `translateY(${dialog.clientHeight + 20}px)`;
          previewDragTimer = setTimeout(close, reducedMotion() ? 0 : 180);
        } else restorePreviewDrag();
      } else {
        resetPreviewDrag();
        if (!gesture.handle && (!gesture.mobile || gesture.direction === 'horizontal') && Math.abs(dx) >= 48 && Math.abs(dx) > Math.abs(dy) * 1.25) {
          showImage(previewIndex + (dx < 0 ? 1 : -1));
        }
      }
    };
    [stage, previewHandle].filter(Boolean).forEach(surface => {
      on(surface, 'pointerdown', beginPreviewDrag);
      on(surface, 'pointermove', movePreviewDrag);
      on(surface, 'pointerup', endPreviewDrag);
      ['pointercancel','lostpointercapture'].forEach(name => on(surface, name, () => { if (swipe) restorePreviewDrag(); }));
    });
    on(dialog, 'touchstart', event => {
      previewTouches = event.touches.length;
      if (previewTouches > 1 && swipe) restorePreviewDrag();
    }, {passive:true});
    ['touchend','touchcancel'].forEach(name => on(dialog, name, event => { previewTouches = event.touches.length; }, {passive:true}));
    on(dialog, 'close', resetPreviewDrag);
    on(window, 'resize', () => { if (swipe || previewDragTimer) resetPreviewDrag(); });
    function destroyPreviewViewer() {
      previewViewerObserver?.disconnect(); previewViewerObserver = null;
      const viewer = previewViewer; previewViewer = null;
      if (viewer) viewer.destroy();
      stage.classList.remove('ag-pdp-preview__stage--zoom');
    }
    function createPreviewViewer() {
      destroyPreviewViewer();
      const PhotoSwipe = window.MinimogLibs?.PhotoSwipeLightbox?.PhotoSwipe;
      if (!PhotoSwipe || !window.AdriaPdpZoom) return; // The image fallback stays usable if a script fails.
      const items = previewSources.map(source => ({src:source.dataset.src, alt:source.dataset.alt,
        width:Number(source.dataset.width), height:Number(source.dataset.height)}));
      if (items.some(item => !item.width || !item.height)) return;
      // PhotoSwipe only loops with >=3 items; duplicate the two-item album, not its logical count.
      const physicalItems = items.length === 2 ? [...items,...items] : items;
      const viewer = new PhotoSwipe({
        ...window.AdriaPdpZoom.options({root}), dataSource:physicalItems, index:previewIndex,
        appendToEl:stage, mainClass:'ag-pdp-embedded-zoom', bgOpacity:0,
        close:false, zoom:false, arrowPrev:false, arrowNext:false, counter:false, preloader:false,
        errorMsg:previewError.textContent.replace(/[&<>"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[char])),
        trapFocus:false, returnFocus:false, escKey:false, arrowKeys:false,
        closeOnVerticalDrag:false, loop:items.length>1,
        getViewportSizeFn:() => ({x:stage.clientWidth,y:stage.clientHeight}),
        padding:{top:0,bottom:0,left:0,right:0}
      });
      previewViewer = viewer;
      const adapter = window.AdriaPdpZoom.attach(viewer,{embedded:true,stage});
      viewer.on('change', () => showImage(viewer.currIndex % items.length,true));
      viewer.on('close', () => { if (previewViewer === viewer && dialog.open) close(); });
      viewer.on('contentLoadImage', () => { previewError.hidden = true; });
      viewer.on('loadComplete', event => { if (event.isError) previewError.hidden = false; });
      viewer.on('pointerDown', event => {
        if (adapter.isGestureBlocked()) { resetPreviewDrag(); return; }
        if (!matchMedia('(max-width:767px)').matches) return;
        const e=event.originalEvent, slide=viewer.currSlide;
        if (!e.isPrimary || previewTouches>1) {restorePreviewDrag();return;}
        if (!slide || !adapter.atInitial(slide)) {swipe=null;return;}
        swipe={id:e.pointerId,x:e.clientX,y:e.clientY,lastY:e.clientY,lastTime:performance.now(),velocity:0,dy:0,mobile:true,direction:null};
      });
      viewer.on('pointerMove', event => {
        if (adapter.isGestureBlocked()) { resetPreviewDrag(); return; }
        if (!swipe || previewTouches>1 || previewPanel.scrollTop>1) return;
        const e=event.originalEvent;
        if (e.pointerId!==swipe.id) return;
        const dx=e.clientX-swipe.x, dy=e.clientY-swipe.y;
        if (!swipe.direction && Math.max(Math.abs(dx),Math.abs(dy))>=10)
          swipe.direction=Math.abs(dx)>=Math.abs(dy)?'horizontal':'dismiss';
        // Reserve vertical movement before PhotoSwipe starts its pan; horizontal movement stays native.
        if (swipe.direction==='horizontal' || (!swipe.direction && Math.abs(dx)>=Math.abs(dy))) return;
        event.preventDefault();
        const now=performance.now();
        swipe.velocity=(e.clientY-swipe.lastY)/Math.max(1,now-swipe.lastTime);
        swipe.lastY=e.clientY;swipe.lastTime=now;swipe.dy=Math.max(0,dy);
        previewPanel.style.transition='none';previewPanel.style.transform=`translateY(${swipe.dy}px)`;
      });
      viewer.on('pointerUp', event => {
        if (adapter.isGestureBlocked()) { resetPreviewDrag(); return; }
        if (!swipe) return;
        if (swipe.direction==='dismiss') {
          event.preventDefault(); // A dismissed/returned card gesture is never an image tap.
          if (event.originalEvent.type.includes('cancel')) {restorePreviewDrag();return;}
          endPreviewDrag({pointerId:swipe.id,clientX:swipe.x,clientY:swipe.y+swipe.dy});
        } else swipe=null;
      });
      stage.classList.add('ag-pdp-preview__stage--zoom');
      viewer.init(); adapter.offset();
      previewViewerObserver=new ResizeObserver(() => {
        if (!dialog.open || previewViewer!==viewer || previewViewerUpdating) return;
        previewViewerUpdating=true;
        viewer.updateSize(true); adapter.offset();
        previewViewerUpdating=false;
      });
      previewViewerObserver.observe(stage);
    }
    options.forEach(input => on(input,'change',() => select(input)));
    const openCart = opener => {
      const cart = document.querySelector('m-cart-drawer');
      if (cart?.open && window.MinimogSettings?.enable_cart_drawer !== false) cart.open(opener);
      else window.location.assign(button.dataset.cartUrl || window.Shopify.routes.root + 'cart');
      schedulePosition();
    };
    on(button,'click',event => {
      if (!busy && data.stockEnquiry && selected && !selected.available) {
        event.preventDefault(); event.stopImmediatePropagation();
        if (enquiryAdded) { openCart(button); return; }
        const saved = window.AdriaStockEnquiry?.add({productId:data.productId,handle:data.productHandle,title:data.fullProductTitle}, selected, Number(form.elements.quantity?.value || 1), button, {stayOnPage:true});
        if (saved) {
          enquiryAdded = true;
          pendingSelection = {id:selected.id,title:compact ? data.noticeProductTitle : data.productTitle,name:selectionName(selected)};
          states(); notice(window.AdriaStockEnquiry.text.added,true); pendingSelection = null;
        }
        return;
      }
      if (!added || busy) return;
      event.preventDefault();
      openCart(button);
    });
    on(stickyBuy,'click',() => {
      if (busy || !selected || (!selected.available && !data.stockEnquiry)) return;
      if (added) { openCart(stickyBuy); return; }
      // Delegate to the real button: its click handlers, validity checks and form submit stay authoritative.
      button.click();
      if (!busy) {
        const missing = form.querySelector(':invalid') ||
          window.validateForm?.(form.closest('.m-main-product--info'))?.[0];
        if (missing) {
          const details = missing.closest('details');
          if (details) details.open = true;
          window.scrollTo({top: scrollY + missing.getBoundingClientRect().top - headerBottom() - 24, behavior:'instant'});
          missing.focus({preventScroll:true});
          schedulePosition();
        }
      }
    });
    // Enter in another form control must not submit a second copy after success.
    on(form,'submit',event => {
      if (!busy && data.stockEnquiry && selected && !selected.available) {
        event.preventDefault(); event.stopImmediatePropagation(); button.click(); return;
      }
      const submitted = data.variants.find(variant => String(variant.id) === form.elements.id.value);
      if (added || busy || !selected?.available || !submitted?.available) { event.preventDefault(); event.stopImmediatePropagation(); }
    },{capture:true});
    on(root.querySelector('[data-ag-return-to-choices]'),'click',() => {
      window.scrollTo({ top: scrollY + actions.getBoundingClientRect().top - headerBottom() - 20,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      (options.find(input => input.checked && !input.disabled) || button).focus({preventScroll:true});
    });
    // Recognize only known localized Shopify inventory wording, never an HTTP status alone.
    // Keep unfamiliar messages intact rather than guessing at the failure reason.
    const compactError = message => {
      const text = String(message).trim();
      if (/^(?:Maksimalna količina ove stavke već je u košarici\.?|The maximum quantity of this item is already in your cart\.?)$/iu.test(text) ||
          /^You can't add more .+ to the cart\.?$/iu.test(text)) return data.quantityError;
      if (/^Proizvod\s+.+\s+(?:već je|je) rasprodan\.?$/iu.test(text) ||
          /^(?:The product\s+)?[“"']?.+[”"']? is already sold out\.?$/iu.test(text)) return data.soldOutError;
      return text;
    };
    const notice = (text, success) => {
      clearTimeout(timer);
      if (compact) {
        const content = banner.querySelector('.ag-pdp-added__content');
        content.setAttribute('role', success ? 'status' : 'alert');
        content.setAttribute('aria-live', success ? 'polite' : 'assertive');
      }
      banner.querySelector('[data-ag-banner-label]').textContent = text;
      const details = banner.querySelector('[data-ag-banner-details]');
      const title = banner.querySelector('[data-ag-banner-title]');
      const option = banner.querySelector('[data-ag-banner-option]');
      const addedSelection = success || compact ? pendingSelection : null;
      title.textContent = addedSelection?.title || '';
      if (compact) option.textContent = addedSelection?.name || '';
      else setMotifLabel(option, addedSelection?.id, addedSelection?.name);
      option.hidden = !addedSelection?.name;
      details.hidden = !addedSelection;
      banner.hidden = false;
      position();
      if (success) timer = setTimeout(() => banner.hidden = true,5000);
    };
    on(root,'ag:pdp:add:start',() => {
      const submitted = data.variants.find(variant => String(variant.id) === form.elements.id.value);
      pendingSelection = submitted ? { id: submitted.id, title: compact ? data.noticeProductTitle : data.productTitle, name: selectionName(submitted) } : null;
      busy = true; banner.hidden = true; productForm.querySelector('.m-product-form-message').textContent = ''; states();
    });
    on(root,'ag:pdp:add:success',() => { added = true; states(); notice(addedText,true); });
    on(root,'ag:pdp:add:error',event => {
      const message = event.detail?.message || data.error;
      productForm.querySelector('.m-product-form-message').textContent = compact ? '' : message;
      notice(compact ? compactError(message) : message,false);
    });
    on(root,'ag:pdp:add:settled',() => { busy = false; pendingSelection = null; states(); });
    on(root.querySelector('[data-ag-banner-close]'),'click',() => { clearTimeout(timer); banner.hidden = true; });
    on(window,'scroll',schedulePosition,{passive:true}); on(window,'resize',schedulePosition);
    on(window.visualViewport,'resize',schedulePosition); on(window.visualViewport,'scroll',schedulePosition,{passive:true});
    on(mobileQuery,'change',schedulePosition);
    const observer = new IntersectionObserver(schedulePosition);
    [actions, button, choicesStart].forEach(el => observer.observe(el));
    const layoutObserver = new ResizeObserver(schedulePosition);
    [actions, fixed, root.querySelector('.ag-pdp-heading')].forEach(el => layoutObserver.observe(el));
    // Observe panel state only; ignore gallery transforms and our own sticky visibility updates.
    const panelObserver = new MutationObserver(records => {
      if (!data.mobileStickyBuy) return;
      const panelNode = el => el instanceof Element && el.matches('dialog, .pswp, .m-modal, m-cart-drawer, m-search-popup, [role="dialog"]');
      if (records.some(record => record.target === document.documentElement || record.target === document.body ||
          panelNode(record.target) || (record.type === 'childList' && [...record.addedNodes, ...record.removedNodes]
            .some(el => panelNode(el) || (el instanceof Element && el.querySelector(modalSelector)))))) schedulePosition();
    });
    panelObserver.observe(document.documentElement,{subtree:true,attributes:true,attributeFilter:['class','open','hidden','aria-hidden','aria-modal','style'],childList:true});
    on(document,'shopify:section:unload',event => {
      if (!event.target.contains(root)) return;
      close(); clearTimeout(timer); clearTimeout(optionSettleTimer); cancelAnimationFrame(frame); cancelAnimationFrame(optionFrame); galleryResize?.disconnect(); observer.disconnect(); layoutObserver.disconnect(); panelObserver.disconnect(); events.abort(); footerSpacer.remove(); root.classList.remove('ag-pdp-permanent-buy'); delete root.dataset.agPurchaseReady;
    });
    const syncWishlist = () => window.MinimogTheme?.Wishlist?.setWishlistButtonsState();
    syncWishlist();
    on(window, 'load', syncWishlist, {once:true});
    syncChoiceLayout();
    renderOptionGallery(selected?.id || options[0]?.value);
    on(document,'ag:stock:ready',states);
    on(document,'ag:stock:change',states);
    states(); schedulePosition();
  }
  function initAll(scope=document) { scope.querySelectorAll('[data-ag-pdp-purchase]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initAll()); else initAll();
  document.addEventListener('shopify:section:load',event => initAll(event.target));
})();
